import { ChapterHeader, FadeUp } from "./Motion";
import { GraduationCap, BookOpen, Users, Lock } from "lucide-react";

export default function Academics({ content }) {
    const ac = content.academics;
    return (
        <section id="academics" className="relative py-20 md:py-32 border-t border-white/10">
            <div className="max-w-[1600px] mx-auto px-5 md:px-10">
                <ChapterHeader num="04" kicker="Student-Athlete" title="Academic Profile" testId="chapter-academics" />

                <FadeUp>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-white/10 border border-white/10">
                        {/* Massive GPA */}
                        <div className="md:col-span-6 p-8 md:p-14 bg-black relative overflow-hidden" data-testid="gpa-block">
                            <div className="absolute inset-0 radial-gold opacity-40" />
                            <div className="relative">
                                <div className="chapter-num">Grade Point Average</div>
                                <div className="font-mono text-brand-gold text-[22vw] md:text-[10vw] leading-none mt-4 tracking-tighter">
                                    {ac.gpa}
                                </div>
                                <div className="chapter-num mt-4">
                                    Out of 4.0 <span className="text-white/30 mx-2">/</span> Class of{" "}
                                    {ac.graduationYear}
                                </div>
                            </div>
                        </div>

                        <div className="md:col-span-6 grid grid-cols-2 gap-px bg-white/10">
                            <div className="p-6 bg-black">
                                <div className="chapter-num flex items-center gap-2">
                                    <GraduationCap size={12} /> ACT
                                </div>
                                <div className="font-mono text-2xl md:text-3xl mt-3 text-brand-gold">
                                    Testing Soon
                                </div>
                                <p className="editorial text-white/70 mt-3">
                                    Registered — first sitting on the calendar.
                                </p>
                            </div>
                            <div className="p-6 bg-black">
                                <div className="chapter-num flex items-center gap-2">
                                    <GraduationCap size={12} /> SAT
                                </div>
                                <div className="font-mono text-2xl md:text-3xl mt-3 text-brand-gold">
                                    Testing Soon
                                </div>
                                <p className="editorial text-white/70 mt-3">
                                    Preparation underway.
                                </p>
                            </div>
                            <div className="p-6 bg-black col-span-2">
                                <div className="chapter-num flex items-center gap-2">
                                    <BookOpen size={12} /> Intended Major
                                </div>
                                <div className="font-mono text-xl md:text-2xl mt-3">{ac.intendedMajor}</div>
                                <p className="editorial text-white/70 mt-3">
                                    Focused on physical therapy — helping people rebuild strength and return to
                                    what they love.
                                </p>
                            </div>
                            <div className="p-6 bg-black col-span-2">
                                <div className="chapter-num">NCAA Eligibility Center</div>
                                <div className="font-mono text-sm md:text-base mt-3 text-white/90">
                                    {ac.ncaaStatus}
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeUp>

                <FadeUp delay={0.15}>
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
                        <div className="p-6 md:p-8 bg-black">
                            <div className="chapter-num flex items-center gap-2">
                                <BookOpen size={12} /> Academic Interests
                            </div>
                            <p className="editorial text-lg md:text-xl mt-4 text-white/90 leading-snug">
                                {ac.academicInterests}
                            </p>
                        </div>
                        <div className="p-6 md:p-8 bg-black">
                            <div className="chapter-num flex items-center gap-2">
                                <Users size={12} /> Leadership
                            </div>
                            <p className="editorial text-lg md:text-xl mt-4 text-white/90 leading-snug">
                                {ac.leadership}
                            </p>
                            <div className="mt-5 flex flex-wrap gap-2">
                                {(ac.qualities || []).map((q) => (
                                    <span
                                        key={q}
                                        className="font-mono text-[10px] uppercase tracking-[0.2em] border border-white/20 px-2.5 py-1 text-white/80"
                                    >
                                        {q}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </FadeUp>

                <FadeUp delay={0.25}>
                    <div className="mt-8 border border-white/10 p-5 md:p-6 flex items-start gap-3 bg-black">
                        <Lock size={14} className="text-brand-gold mt-1 shrink-0" />
                        <p className="font-mono text-xs md:text-sm uppercase tracking-[0.15em] text-white/70 leading-relaxed">
                            {ac.transcriptStatement}
                        </p>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
